import React from 'react';

const LoadingSpinner = ({ size = 'medium', text = '' }) => {
	const sizeClass = {
		small: 'w-6 h-6',
		medium: 'w-10 h-10',
		large: 'w-16 h-16'
	}[size];

	return (
		<div className="flex flex-col items-center justify-center gap-4">
			<div className={`loading-spinner ${sizeClass}`}></div>
			{text && <p className="text-gray-600">{text}</p>}
		</div>
	);
};

export default LoadingSpinner;